import React from 'react';
import cx from 'classnames';
import Icon from '../../Icon';
import { MENU_LINK, EMPTY_MENU_LINK_ICON, LINKS_SEPARATOR } from '../styles/navMenu';
import Text from '../../Text';

















const DEFAULT_ICON_COLOR = 'denim';

function getIconColor({ selected, selectedColour, iconColour, linkColour, admin }) {
  if (selected && selectedColour) {return selectedColour;}

  // Icon-only colour (e.g. a green status dot) — independent of the text colour.
  if (iconColour) {return iconColour;}

  if (linkColour) {return linkColour;}

  if (admin) {return 'white';}

  if (selected) {return 'darkDenim';}

  return DEFAULT_ICON_COLOR;
}

export default function NavigationLink({
  onClick,
  icon,
  label = '',
  withSeparator,
  hasSubmenu,
  selected,
  active,
  expanded,
  indented,
  selectedColour,
  iconColour,
  iconSize,
  className,
  rounded,
  linkColour,
  linkHoverColor,
  linkSelectedColor,
  admin = false,
  exit = false
}) {
  const resolvedIconColour = getIconColor({ selected, selectedColour, iconColour, linkColour, admin });
  const id = `nav-item-${label.replace(/\s/g, '').toLowerCase()}`;

  return (
    <>
      <button
        id={id}
        data-cy={id}
        type="button"
        className={cx(MENU_LINK({
          selected,
          selectedColour,
          rounded,
          indented,
          linkColour,
          linkHoverColor,
          linkSelectedColor,
          admin,
          exit
        }), className)}
        onClick={onClick}>

        {
        icon ?

        <Icon
          name={icon}
          size={iconSize || (admin ? 20 : 24)}
          color={resolvedIconColour} /> :


        <div className={EMPTY_MENU_LINK_ICON} />}

        <Text noMargin button={Boolean(selected || active)}>{label}</Text>
        {hasSubmenu &&
        <Icon
          name={expanded ? 'chevrondown' : 'chevronright'}
          color="denim"
          size={12} />}


      </button>
      {withSeparator &&
      <hr key={`key-${id}`} className={cx(LINKS_SEPARATOR)} />}

    </>);

}